import styled from 'styled-components';

export const RulesSection = styled.section``;

export const RulesHeading = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 24px;
  line-height: 1;
`;

export const RulesList = styled.div`
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }

  li {
    position: relative;
    
    padding-left: 20px;
    
    font-size: 16px;
    line-height: 18px;
    
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      background-color: #a8a8a8;
      border-radius: 50%;
    }
  }
`;
